import React, { createContext, useContext, useState, useCallback } from 'react';

const EarlyUserIdentificationContext = createContext({});

export const EarlyUserIdentificationProvider = ({ children }) => {
  const [earlyUserIdentifier, setEarlyUserIdentifier] = useState(() => {
    return localStorage.getItem('earlyUserIdentifier') || null;
  });

  const setIdentifier = useCallback((identifier) => {
    if (identifier && identifier.trim()) {
      setEarlyUserIdentifier(identifier);
      localStorage.setItem('earlyUserIdentifier', identifier);
    }
  }, []);

  const clearIdentifier = useCallback(() => {
    setEarlyUserIdentifier(null);
    localStorage.removeItem('earlyUserIdentifier');
  }, []);

  return (
    <EarlyUserIdentificationContext.Provider
      value={{
        earlyUserIdentifier,
        setIdentifier,
        clearIdentifier
      }}
    >
      {children}
    </EarlyUserIdentificationContext.Provider>
  );
};

export const useEarlyUserIdentification = () => {
  const context = useContext(EarlyUserIdentificationContext);
  if (!context) {
    throw new Error('useEarlyUserIdentification must be used within EarlyUserIdentificationProvider');
  }
  return context;
}; 
